<template>
  <div class="login_bg">
    <div class="under_bg">
      <div class="content">
        <div class="title">
          <p>2023-2024学年全国中小学信息技术创新与实践大赛</p>
          <p class="title_small">软件创意编程赛项</p>
        </div>
        <div class="login_modal">
          <LoginModal></LoginModal>
        </div>
        <p class="footer">版权所有 全国中小学信息技术创新与实践大赛 （缩写“NOC”）</p>
      </div>
    </div>
  </div>
</template>
<script>
import LoginModal from './components/LoginBox2024.vue'
import { mapGetters } from 'vuex'
// let loginBg = require('../../assets/login/qt_bg.png')
export default {
  components: { LoginModal },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['loginStatus']),
  },
  // watch: {
  //   loginStatus: {
  //     handler(val) {
  //       if (val) {
  //         this.$router.push({ path: '/' })
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  created() { },
  methods: {},
}
</script>
<style scoped>
.login_bg {
  width: 100%;
  height: 100%;
  background: url(../../assets/login/qt_bg.png) repeat-x #daedfb;
  text-align: center;
  margin: 0px;
  position: relative;
}

.under_bg {
  height: 489px;
  background: url(../../assets/login/qt_di.png) no-repeat center;
}

.content {
  max-width: 750px;
  max-height: 590px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.footer {
  color: #444;
  font-size: 16px;
  text-align: center;
  margin-top: 60px;
}

.title {
  color: #fff;
  font-size: 32px;
  line-height: 30px;
  text-align: center;
}

.title_small {
  font-size: 20px;
  line-height: 30px;
}

.login_modal {
  width: 500px;
  margin: 0 auto;
}</style>